import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePropertyTypesAndFeatures } from '../hooks/usePropertyTypesAndFeatures';
import { usePropertyFields } from '../hooks/usePropertyFields';
import { useSearch } from '../contexts/SearchContext';
import './ListingCard.css';

function ListingCard({ property, title, propertyType, propertyTypeLabel, statusIcon, image, isAvailable = true, propertyId, onCardClick }) {
  const navigate = useNavigate();
  const { getPropertyTypeLabel } = usePropertyTypesAndFeatures();
  const { investmentData } = useSearch();
  const { fieldConfigs, renderPropertyField } = usePropertyFields(investmentData, 'list');

  const handleClick = () => {
    if (onCardClick) {
      onCardClick(propertyId);
      return;
    }
    navigate(`/properties/${encodeURIComponent(propertyId)}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const displayPropertyTypeLabel = propertyTypeLabel || getPropertyTypeLabel(propertyType);
  const displayTitle = propertyType ? `${displayPropertyTypeLabel} ${title}` : title;

  return (
    <div className={`property-card ${isAvailable ? 'available' : 'unavailable'}`} onClick={handleClick}>
      <div className="property-image">
        {image ? (
          <img src={image} alt={displayTitle} />
        ) : (
          <svg className="property-image-placeholder" viewBox="0 0 120 100" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="5" y="5" width="110" height="90" rx="4" />
            <line x1="5" y1="40" x2="60" y2="40" />
            <line x1="60" y1="5" x2="60" y2="60" />
            <line x1="60" y1="60" x2="115" y2="60" />
            <rect x="20" y="50" width="25" height="20" rx="2" strokeDasharray="3 2" />
            <rect x="70" y="15" width="30" height="18" rx="2" strokeDasharray="3 2" />
          </svg>
        )}
        {property.priceBadge?.isVisible && (
          <div
            className="promo-badge"
            style={{ background: property.priceBadge.backgroundColor, color: property.priceBadge.textColor }}
          >
            {property.priceBadge.label}
          </div>
        )}
      </div>

      <div className="property-content">
        <div className="property-header">
          <h3 className="property-title">{displayTitle}</h3>
          <div className="property-status">
            <img src={statusIcon} alt="Status" />
          </div>
        </div>

        <div className={`property-details ${property.useSingleColumnLayout ? 'single-column' : ''}`}>
          {fieldConfigs.map(fieldConfig => {
            const result = renderPropertyField(fieldConfig, property);
            if (!result) return null;
            const { label, value, promo } = result;
            return (
              <div key={fieldConfig.field.key} className="property-detail">
                <span className="detail-label">{label}:</span>
                <span className="detail-value">
                  {value}
                  {promo && (
                    <span className="property-price-original">{promo.originalPrice}</span>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ListingCard;
